/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../$$_gendir/node_modules/angular2-notifications/src/simple-notifications/components/simple-notifications.component.ngfactory';
import * as i2 from 'angular2-notifications/src/simple-notifications/components/simple-notifications.component';
import * as i3 from 'angular2-notifications/src/simple-notifications/services/notifications.service';
import * as i4 from '@angular/router';
import * as i5 from '../../app/app.component';
import * as i6 from '@ngx-translate/core/src/translate.service';
const styles_AppComponent:any[] = ([] as any[]);
export const RenderType_AppComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'simple-notifications',
      ([] as any[]),(null as any),(null as any),(null as any),i1.View_SimpleNotificationsComponent_0,
      i1.RenderType_SimpleNotificationsComponent)),i0.ɵdid(1,245760,(null as any),
      0,i2.SimpleNotificationsComponent,[i3.NotificationsService],{options:[0,'options']},
      (null as any)),(_l()(),i0.ɵeld(2,16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(3,212992,(null as any),0,i4.RouterOutlet,[i4.ChildrenOutletContexts,
          i0.ViewContainerRef,i0.ComponentFactoryResolver,[8,(null as any)],i0.ChangeDetectorRef],
          (null as any),(null as any))],(_ck,_v) => {
    var _co:i5.AppComponent = _v.component;
    const currVal_0:any = _co.options;
    _ck(_v,1,0,currVal_0);
    _ck(_v,3,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'app-root',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i0.ɵdid(1,49152,(null as any),0,i5.AppComponent,[i6.TranslateService],(null as any),
          (null as any))],(null as any),(null as any));
}
export const AppComponentNgFactory:i0.ComponentFactory<i5.AppComponent> = i0.ɵccf('app-root',
    i5.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovV09SSy9aRU5OL21jci1jb250YWJpbGlkYWRlLWZpbGVzaGFyZS9BcHBsaWNhdGlvbi9BcHBsaWNhdGlvblVJL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9XT1JLL1pFTk4vbWNyLWNvbnRhYmlsaWRhZGUtZmlsZXNoYXJlL0FwcGxpY2F0aW9uL0FwcGxpY2F0aW9uVUkvc3JjL2FwcC9hcHAuY29tcG9uZW50LnRzIiwibmc6Ly8vQzovV09SSy9aRU5OL21jci1jb250YWJpbGlkYWRlLWZpbGVzaGFyZS9BcHBsaWNhdGlvbi9BcHBsaWNhdGlvblVJL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cy5BcHBDb21wb25lbnQuaHRtbCIsIm5nOi8vL0M6L1dPUksvWkVOTi9tY3ItY29udGFiaWxpZGFkZS1maWxlc2hhcmUvQXBwbGljYXRpb24vQXBwbGljYXRpb25VSS9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHNpbXBsZS1ub3RpZmljYXRpb25zIFtvcHRpb25zXT1cIm9wdGlvbnNcIj48L3NpbXBsZS1ub3RpZmljYXRpb25zPjxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD4iLCI8YXBwLXJvb3Q+PC9hcHAtcm9vdD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7Z0RBQUEsVUFBQTtNQUFBO01BQUEsZUFBaUU7TUFBQTthQUFBOzBEQUFBO1VBQUE7O0lBQTNDO0lBQXRCLFdBQXNCLFNBQXRCO0lBQWlFOzs7O29CQ0FqRTtNQUFBO2FBQUE7VUFBQTs7OyJ9



// WEBPACK FOOTER //
// C:/WORK/ZENN/mcr-contabilidade-fileshare/Application/ApplicationUI/src/$$_gendir/app/app.component.ngfactory.ts